<template>
  <div v-if="(tipo === '1')" :class="'bannerContactos ' + (background === 'true' ? 'background-image' : 'backgroundColor-white')">
    <div class="auto-container">
      <div class="title-group text-center">
        <div class='subtitulo' v-html="fc_getText(null, 'ban_contactos_subtitulo1')" ></div>
      </div>
      <div class="btn flex w-full">
        <div @click="fc_goRoute('contactos')" class="btn-redireciona flex" v-html="fc_getText(null, 'btn_contactos')"></div>
      </div>
    </div>
  </div>
  <div v-if="(tipo === '2')" class="bannerContactos" style="background-color: #f9f9f9 !important;">
    <div class="auto-container">
      <div class="flex flex-wrap">
        <div class="title-column w-full lg:w-6" style="text-align:left;">
          <div class="title-group">
              <span class="sectionTitle" style="color:black" v-html="fc_getText(null, 'contacte_nos', { upper: true })"></span>
              <div class="subtitulo" style="color: black;" v-html="fc_getText(null, 'ban_contactos_subtitulo2')"></div>
              <div class="conteudo" style="color: black;" v-html="fc_getText(null, 'ban_contactos_conteudo2')"></div>
          </div>
        </div>
        <div class="btn flex w-full lg:w-6">
          <div @click="fc_goRoute('contactos')" class="btn-redireciona flex" v-html="fc_getText(null, 'btn_contactos')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
    };
  },
  props: {
    tipo: String,
    background: String,
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<style scoped>
  .bannerContactos {
    position: relative;
    padding-bottom: 55px;
  }
  .auto-container {
    padding: 100px 15px 50px 15px;
  }
  .bannerContactos .title-group {
    position: relative;
    margin-bottom: 30px;
  }
  .bannerContactos .title-group .conteudo {
    margin-top: 20px;
  }
  .bannerContactos .btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .background-image {
    background: url("@/assets/banners/magazine_parallax.jpg") no-repeat;
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
  }
  .background-image .subtitulo {
    color:white;
  }
  @media (min-width: 768px) and (max-width: 991px) {
    .bannerContactos .titleColumn {
      margin-bottom: 30px;
    }
  }
  @media only screen and (max-width: 599px) {
    .bannerContactos .title h2 {
        font-size: 24px;
        line-height: 1.3em;
    }
  }

</style>
